import React from 'react';
import { LocalPhoneIcon } from 'drift-ui';
import iconContactMail from '../../assets/iconContactMail.svg';
import styles from './techHelpStyles.scss';
import Analytics from '@Common/analytics';
import { useSelector } from 'react-redux';
import { isFeatureEnabled } from '../../../store/adminShell/selectors';
import { FeatureFlags } from '@Common/featuresFlagsTypes';
import { SUPPORT_EMAIL } from '../../../constants';

export const TechnicalHelpSection = () => {
  const isRtsRebrand = useSelector(isFeatureEnabled(FeatureFlags.RTS_REBRAND));
  const firebaseEvent = (linkType: string) => {
    Analytics.logFirebaseEvent('CONTACT_US', 'TECHNICAL_HELP', 'CLICK', { Description: `Support ${linkType}` });
  };
  return (
    <div className={styles.techHelpContainer}>
      <div className={styles.techHelpText}>
        {isRtsRebrand
          ? 'Contact our support team if you have any questions or feedback regarding the RTS application.'
          : 'Contact our support team if you have any questions or feedback regarding the RTS Pro application.'}
      </div>
      <div className={styles.lineBorder} />
      <div className={styles.techHelpContact}>
        <div className={styles.contactText}>{isRtsRebrand ? 'RTS Support Team' : 'RTS Pro Support Team'}</div>
        <div className={styles.contactPhone}>
          <LocalPhoneIcon className={styles.contactIcon} />
          <a href="tel:8552782552" className={styles.phone} onClick={() => firebaseEvent('Phone')}>
            (855) 278-2552
          </a>
        </div>
        <div className={styles.contactEmail}>
          <img alt="email-icon" src={iconContactMail} />
          <a href={`mailto:${SUPPORT_EMAIL}`} className={styles.email} onClick={() => firebaseEvent('Email')}>
            Message
          </a>
        </div>
      </div>
    </div>
  );
};
